import axios from 'axios';
import qs from 'qs';

// 全局变量，用于标记是否已经弹出过超时提示
let hasShownTimeoutAlert = false;

import { vm } from '../main.js';

/**
 * 统一响应数据格式
 * 将不同格式的后端返回统一为 { code, msg, data } 结构
 */
function normalizeResponse (data) {
	if (data == null) return data
	if (data.code !== undefined) return data
	if (data.header && data.header.ret !== undefined) {
		const ret = data.header.ret
		const ok = ret === '0' || ret === 0
		return {
			code: ok ? 200 : 500,
			msg: data.header.msg,
			data: data.data,
			header: data.header
		}
	}
	return data
}

/**
 * 统一错误数据格式
 * 将 HTTP 错误 / 网络错误 / 超时错误统一为 { code, msg } 结构
 */
function normalizeError (response, error) {
	if (response && response.data) {
		const data = response.data
		if (data.code !== undefined) return data
		if (data.header && data.header.ret !== undefined) {
			return normalizeResponse(data)
		}
		return {
			code: response.status,
			msg: data.msg || data.error || data.message || '请求失败'
		}
	}
	// 超时错误
	if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
		return { code: -2, msg: '请求超时，请稍后重试' }
	}
	// 网络不可用
	if (!window.navigator.onLine) {
		return { code: 0, msg: '网络不可用，请检查网络连接' }
	}
	return { code: -1, msg: error.message || '请求失败' }
}

/**
 * 全局错误提示
 * 支持通过请求配置 silentError: true 跳过提示
 */
function showGlobalError (normalized) {
	if (!vm || !vm.$message) return
	const msg = normalized && normalized.msg ? normalized.msg : '请求失败'
	// 401 登录过期已有专门的 Alert 提示，这里不再重复弹
	if (normalized && normalized.code === 401) return
	vm.$message.error(msg)
}

// 根据环境变量区分接口的默认地址
console.log(process.env.NODE_ENV,'process.env.NODE_EVN');
console.log('VUE_APP_BASE_API', process.env.VUE_APP_BASE_API);

// 统一处理 baseURL 末尾斜杠，避免与接口路径的开头斜杠拼成 //
// 例：'http://xxx.com/' + '/api/xxx' → 'http://xxx.com/api/xxx'
let baseApi = process.env.VUE_APP_BASE_API
if (baseApi && baseApi.endsWith('/')) {
	baseApi = baseApi.slice(0, -1)
}
axios.defaults.baseURL = baseApi

// 设置超时时间：默认 15 秒，避免无限等待
// 文件上传/下载等特殊接口可在具体请求中单独覆盖 timeout
axios.defaults.timeout = 15000;
axios.defaults.withCredentials = false; //是否允许携带凭证

// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';   //get请求处理
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';   //post请求处理
// axios.defaults.transformRequest = data => qs.stringify(data);   //post请求处理

// axios.defaults.headers['Content-Type'] = 'multipart/form-data;charset=UTF-8';   //post请求处理

//设置请求拦截器
axios.interceptors.request.use(config => {
	const url = config.url
	if (!url || url === '/' || url.trim() === '') {
		return Promise.reject(new Error('Invalid request url: empty path'))
	}
    config.url === '/uploadUtil' && (config.headers['content-type'] = 'multipart/form-data;charset=UTF-8');
	// config.url == '/uploadUtil' && (config.headers['Content-Type'] = false);

	let token = JSON.parse(localStorage.getItem('lifeData'))?.vuex_token
	token && (config.headers.Authorization = 'Bearer '+token)

	// 上传文件时 data 为 FormData：必须删除全局默认的 application/json，
	// 让浏览器自动补上 multipart/form-data; boundary=...，
	// 否则后端收到 application/json + multipart 体，报 "Current request is not a multipart request"
	if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
		delete config.headers['Content-Type']
		delete config.headers['content-type']
	}
	return config
}, error => {
    return Promise.reject(error)
})

/**
 * 响应拦截器
 * */
// axios.defaults.validateStatus = status =>{
//     // 自定义响应成功的HTTP状态码
//     return /^(2|3)\d{2}$/.test(status))
// }
axios.interceptors.response.use(response => {

	if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
		return response.data
	}

	if (response.data && response.data.code === 401) {
        if (!hasShownTimeoutAlert) {
            hasShownTimeoutAlert = true;
            vm.$alert('登录已过期,请重新登录', '', {
                confirmButtonText: '确定',
                showClose: false,
                type: 'error',
                callback: action => {
                    hasShownTimeoutAlert = false;
                    vm.$router.replace('/login')
                }
            });
        }
        return response.data
	}

	if (response.data != null) {
		return normalizeResponse(response.data)
	}

	return { code: -1, msg: '响应数据为空' }

}, error => {
	// 【P0 修复】网络错误/HTTP 错误/超时：统一 reject，让组件的 .catch 能捕获到
	// 之前是 return normalized（resolve），导致错误被静默吞掉
    const normalized = normalizeError(error.response, error)

	// 全局错误提示（可通过 silentError: true 跳过）
	if (!error.config || !error.config.silentError) {
		showGlobalError(normalized)
	}

	return Promise.reject(normalized)
})

export default axios
